import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import 'nprogress/nprogress.css';

import App from 'src/App';
import { Provider as ReduxProvider } from "react-redux"
import { store } from './state/store';
import { SidebarProvider } from './contexts/SidebarContext';
import "./index.css"
ReactDOM.render(
  <ReduxProvider store={store}>
    <BrowserRouter>
      <SidebarProvider>
        <App />
      </SidebarProvider>
    </BrowserRouter>
  </ReduxProvider>
  ,
  document.getElementById('root')
);

